module.exports = __webpack_public_path__ + "static/media/ic-local-shipping.f9c98fb0.svg";